import {defineStore} from "pinia";
import {reactive, ref} from "vue";
import {IUser} from "@/interfaces/IUser";
import Auth from "@/services/Auth";
import {useTokensStore} from "@/composables/tokens";

export const useAuthStore = defineStore('auth', () => {
    const authService = new Auth();
    const tokensStore = useTokensStore();

    // Объявляем текущего пользователя
    // Указываем значения пользователя по молчанию
    const auth = reactive<IUser>({
        id: 0,
        name: ''
    });

    const authenticated = ref<Boolean>(false);

    const authorize = async function () {
        const {data} = await authService.login();
        // @ts-ignore
        if (data.status === 'error') {
            return;
        }

        // @ts-ignore
        const {payload: {token}} = data;
        if (!token) {
            return;
        }

        // Устанавливаем токен
        tokensStore.updateToken(token);

        // Помечаем как авторизованного
        authenticated.value = true;
    };

    return {
        authenticated,
        authorize,
        auth,
    }
});